export default __webpack_public_path__ + "static/media/first.38eac62f.svg";